import { isLiveOneTime } from "@outschool/business-rules";
import { isFlexSchedule, isSellerOrg } from "@outschool/ui-components-website";
import { useIsMobile } from "@outschool/ui-utils";
import React from "react";

import DesktopSectionTable from "./DesktopSectionTable";
import MobileSectionTable from "./MobileSectionTable";
import { SectionTableProps } from "./types";

export default function SectionTable({
  isLoading,
  activity,
  sections,
  fetchNextPage,
  totalCount,
  userTimeZone,
  CtaComponent,
}: SectionTableProps) {
  const isMobile = useIsMobile();
  if (isMobile) {
    return (
      <MobileSectionTable
        isLoading={isLoading}
        activity={activity}
        sections={sections}
        totalCount={totalCount}
        fetchNextPage={fetchNextPage}
        userTimeZone={userTimeZone}
        isSellerOrg={isSellerOrg(activity.leader)}
        CtaComponent={CtaComponent}
      />
    );
  }
  return (
    <DesktopSectionTable
      isLoading={isLoading}
      activity={activity}
      sections={sections}
      totalCount={totalCount}
      fetchNextPage={fetchNextPage}
      isFlexSchedule={isFlexSchedule(activity)}
      isOngoing={!!activity.is_ongoing_weekly}
      isOneTime={isLiveOneTime(activity)}
      userTimeZone={userTimeZone}
      isSellerOrg={isSellerOrg(activity.leader)}
      CtaComponent={CtaComponent}
    />
  );
}
